import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ServiceCallDetailService } from './service-call-detail.service';
import { ServiceCallCancelService } from './service-call-cancel.service';

import { PMStatus } from '../../../../model/enum';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { ServiceCall } from '../../../../model';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-service-call-detail',
  templateUrl: './service-call-detail.component.html',
  styleUrls: ['./service-call-detail.component.css']
})
export class ServiceCallDetailComponent implements OnInit {

  @ViewChild('warningModal') warningModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  id = '';
  model: any;
  // statusName;
  pmStatus = PMStatus;
  isDownloading = false;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private serviceCallDetailService: ServiceCallDetailService,
    private serviceCallCancelService: ServiceCallCancelService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.model = new ServiceCall();
    this.getDetail();
  }

  getDetail() {
    this.serviceCallDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            // this.statusNumToStatusName(this.model.status);
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  // statusNumToStatusName(status) {
  //   switch (status) {
  //     case 0: {
  //       this.statusName = 'Arranging';
  //       break;
  //     }
  //     case 1: {
  //       this.statusName = 'Confirmed';
  //       break;
  //     }
  //     case 2: {
  //       this.statusName = 'Completed';
  //       break;
  //     }
  //     case 3: {
  //       this.statusName = 'Cancelled';
  //       break;
  //     }
  //     default: {
  //       this.statusName = 'Unknown';
  //       break;
  //     }
  //   }
  // }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/service']);
    }
    else {
      this.dangerModal.hide();
    }
  }

  cancelPopUp() {
    this.dialog.showModal('showWarnModalBtn');
  }

  cancel() {
    this.warningModal.hide();

    this.serviceCallCancelService.cancel(this.id).subscribe(data => {

      this.dialog.showModal('showSucModalBtn');
      this.model = null;
      // this.chRef.detectChanges();
      // this.router.navigate([this.router.url]);
      this.ngOnInit();
    },
    error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });

  }

  downloadServiceReport() {
    this.isDownloading = true;

    this.serviceCallDetailService.downloadServiceReport(this.model.serviceReportId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  goToFollowup(followup: number) {
    this.router.navigateByUrl('/home/service', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/home/service/detail/' + followup]));
  }

  goToRelatedServiceCall() {
    this.router.navigateByUrl('/home/service', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/home/service/detail/' + this.model.relatedServiceCallId]));
  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-detail/service-call-detail.component.ts